export default {
  id: 'AddLessonDock',
  code: 'CN',
  text: {
    'Edit Lesson': '编辑课节',
  },
}



// WEBPACK FOOTER //
// ./src/template/Docks/AddLesson/locale.js